import { SxProp, useDripsyTheme, View } from 'dripsy';
import { FONT_SIZE, TextCaption } from '../typography/UniTypography';

export enum TAG_COLOR {
  DEFAULT = 'DEFAULT',
  BLUE = 'Blue',
  CYAN = 'Cyan',
  GREY = 'Grey',
  GREEN = 'Green',
  YELLOW = 'Yellow',
  RED = 'Red'
}
interface TagProps {
  label: string;
  color?: string;
  textColor?: string;
  sx?: SxProp;
  tagColor?: TAG_COLOR;
  variant?: FONT_SIZE;
}

export const Tag: React.FC<TagProps> = ({ variant, label, color = '#E6F7FF', textColor = '#000', sx, tagColor }) => {
  const { theme } = useDripsyTheme();

  let tagBackgroundColor = theme.colors?.[`$tag${tagColor}Background`] || color;
  let tagTextColor = theme.colors?.[`$tag${tagColor}Text`] || textColor;

  return (
    <View sx={{ ...styles.container, backgroundColor: tagBackgroundColor, ...sx }}>
      <TextCaption variants={[variant]} sx={{ color: tagTextColor }}>
        {label}
      </TextCaption>
    </View>
  );
};

enum StyleName {
  container = 'container'
}

const styles: Record<StyleName, SxProp> = {
  container: {
    paddingY: 2,
    paddingX: 5,
    width: 'fit-content',
    borderRadius: 100
  }
};
